import { useEffect } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { useAuthModal } from "../contexts/AuthModalContext";

export default function RequireLoggedIn() {
  const { isAuthed, authReady } = useAuth();
  const { openAuthModal } = useAuthModal();

  useEffect(() => {
    if (authReady && !isAuthed) {
      openAuthModal();
    }
  }, [authReady, isAuthed, openAuthModal]);

  if (!authReady) {
    return <div>Loading…</div>;
  }

  if (!isAuthed) {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
}
